import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useState } from 'react';
import PartnerModal from '../PartnerModal';
import EcoImg from 'eco-design/base/eco-img';
import gtm from '@/utils/gtm';

const SuperchargeSolarSection = () => {
    const { t } = useLang('theProduct.SuperchargeSolarSection');
    const [modalVisible, setModalVisible] = useState(false);

    const handleClick = () => {
        setModalVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_pre_order',
            product_name: 'EcoFlow Ocean Pro Be the First to Know_Supercharge your solar',
        });
    };

    return (
        <section className={styles.superchargeSolarSection}>
            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1751247502991/eco-banner-card.webp" />

            <div className="text-container">
                <h2 className="h2">{t(`title`)}</h2>
                <button className="primary-btn" onClick={handleClick}>
                    {t(`btn`)}
                </button>
            </div>
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </section>
    );
};

export default SuperchargeSolarSection;
